/* failed.icon.svg.js */

"use strict";
module.exports = {
    icon: `    
        <svg viewBox="0 0 20 20" preserveAspectRatio="none">
            <path class="foreground-gl" d="M6.81,15.26a1.36,1.36,0,0,1-1.08-2.2l6-7.79a1.36,1.36,0,0,1,2.16,1.67l-6,7.79A1.36,1.36,0,0,1,6.81,15.26Z" transform="translate(-0.08 -0.05)"/><path class="foreground-gl" d="M12.92,15.26a1.36,1.36,0,0,1-1.08-.53l-6-7.79A1.36,1.36,0,0,1,7.95,5.27l6,7.79a1.36,1.36,0,0,1-1.08,2.2Z" transform="translate(-0.08 -0.05)"/><path class="foreground-gl" d="M10,19.86a9.9,9.9,0,1,1,9.9-9.9A9.91,9.91,0,0,1,10,19.86ZM10,1.44A8.52,8.52,0,1,0,18.5,10,8.53,8.53,0,0,0,10,1.44Z" transform="translate(-0.08 -0.05)"/>
        </svg>
     `,
};
